import {
  teamsDarkTheme,
  teamsHighContrastTheme,
  teamsLightTheme,
  type Theme,
} from "@fluentui/react-components";

import type { TeamsTheme } from "@/lib/teamsClient";

export function fluentThemeFor(theme: TeamsTheme): Theme {
  switch (theme) {
    case "dark":
      return teamsDarkTheme;
    case "contrast":
      return teamsHighContrastTheme;
    default:
      return teamsLightTheme;
  }
}
